/**
 * Normalises a CMS-provided canonical path to a host-agnostic pathname.
 *
 * CMS payloads sometimes return an absolute URL (potentially pointing at a non-production
 * host, e.g. beta) instead of a relative path. Stripping the host lets the caller resolve
 * the pathname against the app's own `metadataBase` (the fixed production host), so the
 * canonical URL never leaks a beta/staging domain.
 *
 * @param canonicalPath - An absolute URL or a relative path, with or without a leading slash.
 * @returns The pathname (with search params, if any), always starting with a leading slash.
 */
function toCanonicalPathname(canonicalPath?: string): string {
  if (!canonicalPath) {
    return '/';
  }

  const { pathname, search } = new URL(canonicalPath, 'https://placeholder.local');

  return `${pathname}${search}`;
}

export { toCanonicalPathname };
